import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 63AF9496-BE67-43F7-9DE4-341E0EDC0C62
 * name alpha-z-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-z-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaZCircleOutlineIcon = createSvgIcon(<><path d="M9,7H15V9L11,15H15V17H9V15L13,9H9V7M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" /></>, 'AlphaZCircleOutlineIcon');
export default AlphaZCircleOutlineIcon